<template>
  <div>
    <c-vs-advert v-if="index==4  && isSearchTerm()"></c-vs-advert>
    <article :title="title" class="search-result">
      <h2 class="c-lochmara h2 mt-4 my-2">
        <a :href="url" target="__blank" class="articleTitle" v-html="title"></a>
      </h2>
      <div class="row">
        <div class="col c-chathams ds-4 font-weight-bold">
          <p class="my-2 h3" v-if="status">{{ status }}</p>
          <p v-if="gender" class="h3">
            {{ $t('org.openTo') }}:
            <span class="c-lochmara">{{ parseGender }}</span>
          </p>
          <p v-if="age" class="h3">
            {{ $t('org.age') }}: <span class="c-lochmara">{{ age }}</span>
          </p>
        </div>
        <div class="col-auto">
          <div class="c-chathams font-weight-bold my-3">
            <c-search-result-distance v-if="distance" :distance="distance"></c-search-result-distance>
            <button
              v-if="cities.length"
              aria-expanded="false"
              :aria-label="`${showLocationList? 'Hide' : 'Show'} ${$t('org.cities')}/${$t('org.towns')} ${$t(
              'org.whereThe'
            )} ${title} ${$t('org.studyIsAvailable')}`"
              class="btn d-block w-100 location-toggle btn-location"
              :class="showLocationList ? 'btn--action' : 'btn--nav'"
              @click="showLocationList = !showLocationList"
            >
              {{ $t('org.cities') }}/{{ $t('org.towns') }}
            </button>
            <div class="location-list bg-chathams p-2" v-if="showLocationList">
              <div class="tag-cloud justify-content-end">
                <a
                  target="_blank"
                  :href="city.url"
                  :aria-label="`${$t('org.whereCanITakePartIn')} ${city.name} ${$t(
                    'common.for'
                  )} ${title} ${$t('org.study')} (${$t('ui.opensNewTab')})`"
                  class="tag tag--ziggurat"
                  v-for="city in cities"
                  :key="city.id"
                >
                  {{ city.name }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-3">
        <div class="col">
          <p class="c-chathams h3 font-weight-bold my-2">
            {{ $t('org.medicalConditions') | title }}
          </p>
          <p
            v-for="(condition, index) in firstFivemedicalConditions"
            :key="'medicalCondition' + index"
          >
            {{ condition }}
          </p>
        </div>
      </div>
      <div class="c-tundora my-4 ds-6">
        <i class="c-downriver ds-4 far fa-calendar mr-2"></i> {{ $t('ui.lastUpdated') }}
        <time>{{ getDate(lastUpdated) }}</time>
      </div>
      <a
        :href="url"
        target="__blank"
        :aria-label="`${$t('org.readStudyDetails')} ${$t('common.for')} ${title} (${$t(
          'ui.opensNewTab'
        )})`"
        class="col col-lg-auto btn btn--action my-2"
      >
        {{ $t('org.readStudyDetails') | title }}
        <span class="visuallyhidden">
          {{ $t('common.for') | lowerCase }} {{ title }} ({{ $t('ui.opensNewTab') }})
        </span>
      </a>
    </article>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import SearchResultDistance from '@/components/pages/searchResults/SearchResultDistance'
import VSadvert from '@/components/pages/searchResults/VSadvert.vue'

export default {
  components: { 
    'c-search-result-distance': SearchResultDistance,
    'c-vs-advert':VSadvert 
  },
  props: {
    age: { required: true, type: String },
    cities: { required: true, type: Array },
    distance: [Number, String],
    gender: { required: true, type: String },
    lastUpdated: { required: true, type: String },
    medicalConditions: { required: true, type: Array },
    status: { required: true, type: String },
    title: { required: true, type: String },
    url: { required: true, type: String },
    index: { required: true, type: Number },
  },
  data: () => ({ showLocationList: false }),
  computed: {
    firstFivemedicalConditions() {
      return this.medicalConditions.slice(0, 5)
    },
    parseGender() {
      const { gender } = this
      return gender === 'Both' || gender === 'All' ? 'All Genders' : gender
    },
  },
  methods: {
    isSearchTerm(){

      return !this.$store.getters['search/params'].facetDef["Age Range"] 
      && !this.$store.getters['search/params'].facetDef["Gender"]
      && !this.$store.getters['search/params'].facetDef["Health Category"]
      && !this.$store.getters['search/params'].facetDef["Health Tag"]
      && (this.$store.getters['search/params'].facetDef["Study Status"])
      && this.$store.getters['search/params'].facetDef["Study Status"].length == 1
      && this.$store.getters['search/params'].facetDef["Study Status"][0]=="Recruiting"
    },
    getDate(d) {
      return DateTime.fromISO(d).toLocaleString(DateTime.DATE_MED)
    },
  },
}
</script>

<style lang="scss" scoped>
.articleTitle {
  color: #0c5c86;
}
</style>
